import { VariantProps, cva } from 'class-variance-authority';

export const profileMenuItemStyles = cva(
  [
    'text-left',
    'gap-x-8',
    'flex',
    'items-center',
    'px-12',
    'py-4',
    'cursor-pointer',
  ],
  {
    variants: {
      intent: {
        default: ['fill-grayscale400', 'text-grayscale400'],
        destructive: ['fill-error300', 'text-error300'],
      },
    },
    defaultVariants: {
      intent: 'default',
    },
  },
);

export type ProfileMenuItemStyles = VariantProps<typeof profileMenuItemStyles>;
